module.exports = __webpack_public_path__ + "img/mgh-toyosu-bayside-cross-tokyo@2x.e3926f88.jpg";